import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "p-fluid" }
const _hoisted_2 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_3 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_4 = {
  class: "p-input-icon-left",
  style: {"width":"13em"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_7 = { class: "p-field p-col p-col-12 p-md-12 p-lg-12" }
const _hoisted_8 = { style: {"white-space":"pre-line"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("b", { style: {"white-space":"pre-line"} }, "Mức 1", -1)
const _hoisted_11 = { style: {"white-space":"pre-line","text-align":"left"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", { style: {"white-space":"pre-line"} }, "Mức 2", -1)
const _hoisted_13 = { style: {"white-space":"pre-line","text-align":"left"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("b", { style: {"white-space":"pre-line"} }, "Mức 3", -1)
const _hoisted_15 = { style: {"white-space":"pre-line","text-align":"left"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", { style: {"white-space":"pre-line"} }, "Mức 4", -1)
const _hoisted_17 = { style: {"white-space":"pre-line","text-align":"left"} }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("b", { style: {"white-space":"pre-line"} }, "Mức 5", -1)
const _hoisted_19 = { style: {"white-space":"pre-line","text-align":"left"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, {
    style: {"text-align":"center","height":"80vh"},
    header: "Tiêu chuẩn đánh giá bệnh viện"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($setup.showTable)
            ? (_openBlock(), _createBlock(_component_DataTable, {
                key: 0,
                value: $setup.criteriaTeam,
                resizableColumns: true,
                columnResizeMode: "fit | expand",
                showGridlines: "",
                responsiveLayout: "scroll",
                filters: $setup.filters,
                "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters) = $event)),
                scrollable: true,
                scrollHeight: "72vh",
                scrollWidth: "95vw",
                scrollDirection: "both",
                globalFilterFields: ['ma','tieu_de'],
                style: {"width":"97vw"}
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_Button, {
                      type: "button",
                      icon: "pi pi-filter-slash",
                      label: "Xoá",
                      class: "p-button-outlined",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.clearFilter())),
                      style: {"width":"6em"}
                    }),
                    _createElementVNode("span", _hoisted_4, [
                      _hoisted_5,
                      _createVNode(_component_InputText, {
                        modelValue: $setup.filters['global'].value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters['global'].value) = $event)),
                        placeholder: "Tìm kiếm"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    field: "ma",
                    header: "Mã",
                    style: {"text-align":"center","flex":"5vw","min-width":"60px"}
                  }),
                  _createVNode(_component_Column, {
                    field: "tieu_de",
                    header: "Tiêu đề",
                    style: {"white-space":"pre-line","flex":"60vw","min-width":"150px"}
                  }),
                  _createVNode(_component_Column, {
                    field: "symptoms",
                    header: "Chi tiết",
                    style: {"white-space":"pre-line","flex":"10vw","min-width":"100px"}
                  }, {
                    body: _withCtx((slotProps) => [
                      _createVNode(_component_Button, {
                        label: "Xem nội dung",
                        type: "button",
                        align: "center",
                        onClick: ($event: any) => ($setup.criterialDetailClick(slotProps.data.id))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value", "filters"]))
            : _createCommentVNode("", true),
          _createVNode(_component_Dialog, {
            header: $setup.title,
            visible: $setup.showDetail,
            "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.showDetail) = $event)),
            maximizable: true,
            style: {"width":"90vw","white-space":"pre-line","font-size":"16px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("b", _hoisted_8, _toDisplayString($setup.criterial.can_cu), 1),
                  _hoisted_9,
                  _hoisted_10,
                  _createElementVNode("p", _hoisted_11, _toDisplayString($setup.criterial.muc1), 1),
                  _hoisted_12,
                  _createElementVNode("p", _hoisted_13, _toDisplayString($setup.criterial.muc2), 1),
                  _hoisted_14,
                  _createElementVNode("p", _hoisted_15, _toDisplayString($setup.criterial.muc3), 1),
                  _hoisted_16,
                  _createElementVNode("p", _hoisted_17, _toDisplayString($setup.criterial.muc4), 1),
                  _hoisted_18,
                  _createElementVNode("p", _hoisted_19, _toDisplayString($setup.criterial.muc5), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["header", "visible"])
        ])
      ])
    ]),
    _: 1
  }))
}